export const translations = {
    en: {
        // Common/Shared Text
        SITE_NAME: "86 ICE",
        COPYRIGHT_TEXT: "© 2026 86 ICE. All rights reserved.",

        // Navigation
        NAV_HOME: "Home",
        NAV_REPORT: "Report An Incident",
        NAV_RESTAURANT_GOERS: "Restaurant Goers",
        NAV_RESTAURANT_WORKERS: "Restaurant Workers",
        NAV_RESTAURANT_OWNERS: "Restaurant Owners",

        // Page Titles
        PAGE_TITLE_HOME: "86 ICE",
        PAGE_TITLE_REPORT: "Report An Incident | 86 ICE",
        PAGE_TITLE_RESTAURANT_GOERS: "Restaurant Goers | 86 ICE",
        PAGE_TITLE_RESTAURANT_WORKERS: "Restaurant Workers | 86 ICE",
        PAGE_TITLE_RESTAURANT_OWNERS: "Restaurant Owners | 86 ICE",

        // Home Page
        HERO_TITLE: "86 ICE!",
        HERO_SUBTITLE: "In the hospitality industry, “eighty six” means that something is no longer available, or that someone is kicked out of a bar or restaurant. 86ICE is a worker-led campaign to protect restaurant workers from unconstitutional federal immigration enforcement actions. Let’s 86 ICE now across Minnesota!",
        HERO_CTA_BUTTON: "Take Action",
        HERO_CTA_BUTTON_2: "Report an Incident",
        HERO_IMAGE_ALT: "A set of picket signs positioned in front of a restaurant window with messages supporting restaurant workers and immigrant rights.",
        DEMANDS_SECTION_TITLE: "Our Core Demands",
        RECEIPT_SECTION_TITLE: "Service workers across the state are uniting under these demands to make the industry safer for everyone.",
        RECEIPT_SECTION_IMAGE: "../assets/86Ice_Receipt_Final.png",
        RECEIPT_IMAGE_ALT: "A graphic of a receipt from a restaurant with 86 ICE written across it.",
        ACTIONS_SECTION_TITLE: "Take Action!",
        CTA_SECTION_TITLE: "Incident Report Form",
        CTA_SECTION_DESC: "Has ICE come to your workplace? Have workers gotten in trouble for asking for protections? Has your management resisted making an emergency preparedness plan? Report incidents from your workplace here!",
        CTA_SECTION_BUTTON: "Report an Incident",

        // Features
        DEMAND_PREPAREDNESS_TITLE: "1. Preparedness",
        DEMAND_PREPAREDNESS_DESC: "We demand proactive safety plans for all workplaces to protect staff in the event of a federal law enforcement action & “Know Your Rights” training for all workers and managers.",
        DEMAND_4THAMENDMENT_TITLE: "2. 4th Amendment Rights",
        DEMAND_4THAMENDMENT_DESC: "We will enact our right to deny law enforcement agents access to any private areas of our business without a valid judicial warrant.",
        DEMAND_SAFETY_TITLE: "3. Safety",
        DEMAND_SAFETY_DESC: "We will refuse service to known ICE or federal agents in our establishment to ensure the safety of all workers and customers.",
        DEMAND_SUPPORT_TITLE: "4. Support & Security",
        DEMAND_SUPPORT_DESC: "We demand the right to take time to manage immigration proceedings and to keep ourselves safe, without punishment or fear of losing our jobs.",

        // Actions
        ACTION_RESTAURANT_GOEERS_TITLE: "Restaurant Goers",
        ACTION_RESTAURANT_GOEERS_DESC: "Workers need support from great customers now more than ever. Click here to learn how you can support 86 ICE!",
        ACTION_RESTAURANT_GOEERS_BUTTON: "Support Workers",
        ACTION_RESTAURAUNT_WORKERS_TITLE: "Restaurant Workers",
        ACTION_RESTAURAUNT_WORKERS_DESC: "Get trained on your rights at work and make a plan to protect yourself and your coworkers.",
        ACTION_RESTAURAUNT_WORKERS_BUTTON: "Know Your Rights",
        ACTION_RESTAURAUNT_OWNERS_TITLE: "Restaurant Owners",
        ACTION_RESTAURAUNT_OWNERS_DESC: "Employers in the service industry – we want to work with you! Click here to learn more and join our pledge.",
        ACTION_RESTARUANT_OWNERS_BUTTON: "Join the Pledge",

        // About Page
        REPORT_HEADER_TITLE: "Report an Incident",
        RESTAURANT_GOERS_HEADER_TITLE: "Restaurant Goers",
        RESTAURANT_WORKERS_HEADER_TITLE: "Restaurant Workers",
        RESTAURANT_OWNERS_HEADER_TITLE: "Restaurant Owners",
    },

    es: {
        // Common/Shared Text
        SITE_NAME: "86 ICE",
        COPYRIGHT_TEXT: "© 2026 86 ICE. Todos los derechos reservados.",

        // Navigation
        NAV_HOME: "Inicio",
        NAV_REPORT: "Reportar un Incidente",
        NAV_RESTAURANT_GOERS: "Comensales de Restaurantes",
        NAV_RESTAURANT_WORKERS: "Trabajadores de Restaurantes",
        NAV_RESTAURANT_OWNERS: "Propietarios de Restaurantes",

        // Page Titles
        PAGE_TITLE_HOME: "86 ICE",
        PAGE_TITLE_REPORT: "Reportar un Incidente | 86 ICE",
        PAGE_TITLE_RESTAURANT_GOERS: "Comensales de Restaurantes | 86 ICE",
        PAGE_TITLE_RESTAURANT_WORKERS: "Trabajadores de Restaurantes | 86 ICE",
        PAGE_TITLE_RESTAURANT_OWNERS: "Propietarios de Restaurantes | 86 ICE",
        
        // Home Page
        HERO_TITLE: "86 LA MIGRA!",
        HERO_SUBTITLE: "En la industria de la hospitalidad, “ochenta y seis” significa que algo ya no está disponible, o que alguien es expulsado de un bar o restaurante. 86ICE es una campaña liderada por trabajadores para proteger a los trabajadores de restaurantes de acciones de cumplimiento migratorio federal inconstitucionales. ¡Vamos a ochenta y seis ICE ahora en Minnesota!",
        HERO_CTA_BUTTON: "Tomar Acción",
        HERO_CTA_BUTTON_2: "Reporta un Incidente",
        HERO_IMAGE_ALT: "Un conjunto de carteles de piquete posicionados frente a la ventana de un restaurante con mensajes que apoyan a los trabajadores de restaurantes y los derechos de los inmigrantes.",
        DEMANDS_SECTION_TITLE: "Nuestras Demandas Principales",
        DEMANDS_SECTION_SUBTITLE: "Nos estamos uniendo en ciudades bajo estas demandas para hacer que la industria de servicios sea más segura para todos.",
        RECEIPT_SECTION_TITLE: "Los trabajadores de servicios en todo el estado se están uniendo bajo estas demandas para hacer que la industria sea más segura para todos.",
        RECEIPT_SECTION_IMAGE: "../assets/86LaMigra_Receipt_Final.png",
        RECEIPT_IMAGE_ALT: "Un gráfico de un recibo de un restaurante con 86 La Migra escrito en él.",
        ACTIONS_SECTION_TITLE: "¡Tomar Acción!",
        CTA_SECTION_TITLE: "Formulario de Reporte de Incidentes",
        CTA_SECTION_DESC: "¿Ha venido ICE a tu lugar de trabajo? ¿Los trabajadores han tenido problemas por pedir protecciones? ¿Tu administración se ha resistido a hacer un plan de preparación para emergencias? ¡Reporta incidentes de tu lugar de trabajo aquí!",
        CTA_SECTION_BUTTON: "Reporta un Incidente",

        // Features
        DEMAND_PREPAREDNESS_TITLE: "1. Preparación",
        DEMAND_PREPAREDNESS_DESC: "Exigimos planes de seguridad proactivos para todos los lugares de trabajo para proteger al personal en caso de una acción de cumplimiento de la ley federal y capacitación de “Conoce tus Derechos” para todos los trabajadores y gerentes.",
        DEMAND_4THAMENDMENT_TITLE: "2. Derechos de la Cuarta Enmienda",
        DEMAND_4THAMENDMENT_DESC: "Ejerceremos nuestro derecho a negar a los agentes de la ley el acceso a cualquier área privada de nuestro negocio sin una orden judicial válida.",
        DEMAND_SAFETY_TITLE: "3. Seguridad",
        DEMAND_SAFETY_DESC: "Nos negaremos a servir a agentes conocidos de ICE o federales en nuestro establecimiento para garantizar la seguridad de todos los trabajadores y clientes.",
        DEMAND_SUPPORT_TITLE: "4. Soporte al Cliente",
        DEMAND_SUPPORT_DESC: "Exigimos el derecho a tomarnos el tiempo para manejar los procedimientos de inmigración y mantenernos seguros, sin castigo ni miedo a perder nuestros empleos.",

        // Actions
        ACTION_RESTAURANT_GOEERS_TITLE: "Comensales de Restaurantes",
        ACTION_RESTAURANT_GOEERS_DESC: "Apoya a los restaurantes que protegen los derechos de sus trabajadores y se oponen a los trabajadores. Los grandes clientes necesitan apoyo ahora más que nunca. ¡Haz clic aquí para aprender cómo puedes apoyar a 86 ICE!",
        ACTION_RESTAURANT_GOEERS_BUTTON: "Apoya a los Trabajadores",
        ACTION_RESTAURAUNT_WORKERS_TITLE: "Trabajadores de Restaurantes",
        ACTION_RESTAURAUNT_WORKERS_DESC: "Capacítate sobre tus derechos en el trabajo y haz un plan para protegerte a ti y a tus compañeros de trabajo.",
        ACTION_RESTAURAUNT_WORKERS_BUTTON: "Conoce tus Derechos",
        ACTION_RESTAURAUNT_OWNERS_TITLE: "Propietarios de Restaurantes",
        ACTION_RESTAURAUNT_OWNERS_DESC: "Empleadores en la industria de servicios: ¡queremos trabajar con ustedes! Haga clic aquí para obtener más información y unirse a nuestro compromiso.",
        ACTION_RESTARUANT_OWNERS_BUTTON: "Únete al Compromiso",

        REPORT_HEADER_TITLE: "Reporta un Incidente",
        RESTAURANT_GOERS_HEADER_TITLE: "Comensales de Restaurantes",
        RESTAURANT_WORKERS_HEADER_TITLE: "Trabajadores de Restaurantes",
        RESTAURANT_OWNERS_HEADER_TITLE: "Propietarios de Restaurantes",
    }
};